/** Handlers re-run on Capacitor app resume to rebuild Supabase realtime subscriptions. */

const resumeHandlers = new Set();

export function registerRealtimeResumeHandler(handler) {
  resumeHandlers.add(handler);
  return () => {
    resumeHandlers.delete(handler);
  };
}

export function runRealtimeResumeHandlers() {
  resumeHandlers.forEach((handler) => {
    try {
      handler();
    } catch (err) {
      console.error('[realtime] resume handler failed:', err);
    }
  });
}
